var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldVideoHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7.86v8.33c0 .06 0 .12.01.17h9.24v-8.5H2zM11.251 6.36V2h-3.53v4.24c0 .04-.02.08-.03.12h3.56zM6.219 2.16c-2.22.46-3.67 1.94-4.09 4.2h4.11c-.01-.04-.02-.08-.02-.12V2.16z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.22 2v4.36h-3.47V2h3.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.87 6.358c-.42-2.28-1.89-3.77-4.15-4.21v4.18c0 .01-.01.02-.01.03h4.16zM21.819 17.86h-4.1v3.99c2.19-.43 3.63-1.83 4.1-3.99z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.22 17.86V22h-3.47v-4.14h3.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.99 16.36c.01-.05.01-.11.01-.17V7.86h-9.25v8.5h9.24z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.249 17.86V22h-3.53v-4.14h3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22 21.84v-3.98H2.18c.47 2.14 1.89 3.54 4.04 3.98z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldVideoHorizontal);
export default __webpack_public_path__ + "static/media/vuesax-bold-video-horizontal.941df7fdf27b1cf1b40de10b3160cce1.svg";
export { ForwardRef as ReactComponent };